import React, { useState } from 'react';
import { MapPin, ChevronDown, Check } from 'lucide-react';
import { useLocation } from '@/shared/hooks/useLocation';
import styles from './LocationSwitcher.module.css';

export function LocationSwitcher() {
  const { currentLocation, locations, setCurrentLocation } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  if (!currentLocation) return null;

  if (locations.length <= 1) {
    return (
      <div className={styles.single}>
        <MapPin size={14} className={styles.pinIcon} />
        <span className={styles.locationName}>{currentLocation.name}</span>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <button className={styles.trigger} onClick={() => setIsOpen(!isOpen)}>
        <MapPin size={14} className={styles.pinIcon} />
        <span className={styles.locationName}>{currentLocation.name}</span>
        <ChevronDown size={14} className={styles.chevron} />
      </button>

      {isOpen && (
        <>
          <div className={styles.backdrop} onClick={() => setIsOpen(false)} />
          <div className={styles.dropdown}>
            <div className={styles.dropdownHeader}>Switch Location</div>
            {locations.map((loc) => (
              <button
                key={loc.id}
                className={styles.dropdownItem}
                onClick={() => {
                  setCurrentLocation(loc);
                  setIsOpen(false);
                }}
              >
                <span className={styles.locationItemName}>{loc.name}</span>
                {loc.id === currentLocation.id && <Check size={14} className={styles.check} />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
